import { type ReactNode, useState } from "react";
import { cn } from "./utils/cn";

export interface TabsProps {
  tabs: { value: string; label: ReactNode }[];
  /** Controlled value. If omitted, behaves uncontrolled with defaultValue. */
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  className?: string;
  children: (active: string) => ReactNode;
}

export const Tabs = ({ tabs, value, defaultValue, onChange, className, children }: TabsProps) => {
  const [internal, setInternal] = useState<string>(defaultValue ?? tabs[0]?.value ?? "");
  const active = value ?? internal;
  const handle = (next: string) => {
    if (value === undefined) setInternal(next);
    onChange?.(next);
  };

  return (
    <div className={cn("hui-tabs", className)}>
      <div className="hui-tabs__list" role="tablist">
        {tabs.map((t) => (
          <button
            key={t.value}
            type="button"
            role="tab"
            aria-selected={t.value === active}
            className="hui-tabs__tab"
            onClick={() => handle(t.value)}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="hui-tabs__panel" role="tabpanel">
        {children(active)}
      </div>
    </div>
  );
};
